export const SET_SYSID = "sysId/SET_SYSID";

export const saveSysId = (sysId: string) => {
  return {
    type: SET_SYSID,
    payload: { sysId },
  };
};
